/*global moment*/

import './style.less';
import { keyBy } from 'lodash';
import { or_cpa } from './templates/index';
import pdfMake from 'pdfmake/build/pdfmake.min.js';
import { pdfMake as vfsObject } from 'pdfmake/build/vfs_fonts.js';

pdfMake.vfs = vfsObject.vfs;

export default function($log, $stateParams, $filter) {
  'ngInject';

  const vm = this;
  vm.$onChanges = activate;
  vm.activate = activate;

  const reports = {
    or_cpa,
    or_cpa_m: or_cpa
  };

  function getReport(reg_id) {
    return reports[reg_id];
  }

  vm.generate = () => {
    const docDefinition = getReport(vm.ngModel.reg_id)($filter, vm.ngModel, vm.certsDict, vm.profile);
    pdfMake.createPdf(docDefinition).open();
  };

  function activate() {
    $log.debug('Renewal Report Component Activated');
    vm.loaded = false;
    vm.error = false;
    vm.btnType = vm.btnType || 'btn';
    vm.profileUid = $stateParams.id;
    vm.certsDict = keyBy(vm.certs, 'cert_id');
    vm.loaded = getReport(vm.ngModel.reg_id) !== undefined;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/users/reports/renewals/controller.js